import Loading from 'components/Loading'
import React from 'react'
import Loadable from 'react-loadable'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import modules, { getDetail, getPayLink } from './modules'

export default function(route) {
  const Invoice = Loadable({
    loader: () => import('./components/Invoice'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          routesInvoiceState: state.routesInvoiceState,
          siteConfig: state.siteConfig,
        }),
        {
          getDetail,
          getPayLink
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading,
  })

  return (
    <Route
      path='/invoice'
      render={(routeProps) => (
        <DynamicModuleLoader modules={[modules(route.history)]}>
          <Invoice {...route} />
        </DynamicModuleLoader>)}
    />
  )
}
